module.exports = __webpack_public_path__ + "img/outpost_tech_Normal_ua.23d8fc69.webp";